import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const loginFormStyle = {
    label: {
        fontSize: 'md',
        fontStyle: 'normal',
        lineHeight: 'normal',
        mb: pxToRem(15),
        letterSpacing: pxToRem(1.28),
        color: '#000'
    },
    input: {
        borderRadius: 'initial'
    }
}

export const styleAccountBenefits = {
    '.benefits': {
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: [pxToRem(10), pxToRem(10), pxToRem(0), pxToRem(0)],
        columnGap: [pxToRem(10), pxToRem(10), pxToRem(36), pxToRem(36)],
        marginTop: [pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)],
        marginBottom: [pxToRem(0), pxToRem(0), pxToRem(5), pxToRem(5)],
        paddingLeft: [pxToRem(35), pxToRem(35), pxToRem(16), pxToRem(16)],
        paddingRight: [pxToRem(35), pxToRem(35), pxToRem(16), pxToRem(16)],
        div: {
            display: ['flex', 'flex', 'block', 'block'],
            alignItems: 'center',
            columnGap: [pxToRem(14), pxToRem(14), pxToRem(0), pxToRem(0)],
            flex: ['100%', '100%', '1', '1'],
            img: {
                height: [pxToRem(59), pxToRem(59), pxToRem(59), pxToRem(59)],
                marginLeft: [0, 0, 'auto', 'auto'],
                marginRight: [0, 0, 'auto', 'auto'],
                marginBottom: [pxToRem(0), pxToRem(0), pxToRem(10), pxToRem(10)]
            },
            p: {
                color: 'black',
                fontFamily: fonts.primary,
                fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
                fontWeight: '400',
                lineHeight: 'normal',
                letterSpacing: pxToRem(1),
                margin: 0,
                textAlign: ['left', 'left', 'center', 'center']
            }
        },
        'div:nth-of-type(2)': {
            img: {
                height: [pxToRem(56), pxToRem(56), pxToRem(56), pxToRem(56)]
            }
        },
        'div:nth-of-type(3)': {
            img: {
                height: [pxToRem(54), pxToRem(54), pxToRem(54), pxToRem(54)]
            }
        }
    }
}

export const loyaltyBenefitsStyle = {
    marginTop: {base: `${pxToRem(15)} !important`, lg: `${pxToRem(25)} !important`},
    '.loyalty-benefits': {
        display: 'flex',
        flexDirection: {base: 'column', lg: 'row'},
        gap: {base: pxToRem(10), lg: pxToRem(5)},
        paddingX: {base: pxToRem(25), lg: '0'},
        '.item-container': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: {base: 'row', lg: 'column'},
            width: '100%',
            textAlign: {base: 'left', lg: 'center'},
            gap: {base: pxToRem(15), lg: pxToRem(10)},
            img: {
                height: {base: 'auto', lg: pxToRem(56)},
                width: {base: pxToRem(56), lg: 'auto'}
            },
            p: {
                fontFamily: fonts.primary,
                fontSize: {
                    base: pxToRem(13),
                    lg: pxToRem(12)
                },
                fontStyle: 'normal',
                lineHeight: 'normal',
                letterSpacing: pxToRem(1),
                margin: '0 !important'
            }
        }
    }
}

export const forgotPasswordWrapper = {
    display: 'flex',
    flexWrap: ['wrap', 'wrap', 'nowrap', 'nowrap'],
    columnGap: [pxToRem(5)],
    marginTop: [
        `${pxToRem(9)} !important`,
        `${pxToRem(9)} !important`,
        `${pxToRem(0)} !important`,
        `${pxToRem(0)} !important`
    ]
}

export const errorTextLogin = {
    color: 'cav_error_red',
    display: 'inline',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginTop: [pxToRem(0), pxToRem(0), pxToRem(10), pxToRem(10)],
    marginBottom: '0 !important',
    p: {
        marginBottom: '0 !important',
        lineHeight: 'normal'
    }
}

export const forgotPasswordButtonLogin = {
    ...errorTextLogin,
    color: 'black',
    textDecoration: 'underline',
    marginTop: [pxToRem(0), pxToRem(0), pxToRem(10), pxToRem(10)],
    '&:hover': {
        textDecoration: 'none'
    }
}

export const loginDescriptionTextStyle = {
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    mt: {base: `${pxToRem(12)} !important`, lg: `${pxToRem(20)} !important`}
}
